import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';

let UiCAccountNameComponent = class UiCAccountNameComponent {
    constructor() {
        this.isBack = true;
        this.name = "";
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.count = 0;
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit(this.name);
    }
    onKeyDown(e, value) {
        if (e.which === 32 && (value === '' || value === null)) {
            return false;
        }
        else if (e.which === 32) {
            this.count += 1;
            console.log(this.count);
            if (this.count > 1)
                return false;
        }
        else {
            this.count = 0;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAccountNameComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountNameComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountNameComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountNameComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountNameComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountNameComponent.prototype, "secondaryColor", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountNameComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountNameComponent.prototype, "continue", void 0);
UiCAccountNameComponent = __decorate([
    Component({
        selector: 'ui-c-account-name',
        template: "<div class=\"animation-type\">\n  <ui-c-header-onboarding [isBack]=\"isBack\" [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\" [title]=\"title\"\n    [description]=\"description\" [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" (back)=\"goBack()\">\n  </ui-c-header-onboarding>\n\n  <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"6\">\n      <ion-item class=\"c-input\">\n        <ion-input (keydown)=\"onKeyDown($event,name)\" type=\"text\" [(ngModel)]=\"name\"\n          placeholder=\"{{ 'ONBORDING.V2.FORM.PLACEHOLDER.NAME' | wlpTranslate }}\"\n          class=\"font-family-semibold font-size-18 ion-text-left\" maxlength=\"200\">\n        </ion-input>\n      </ion-item>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button data-cy=\"onboarding-accountname-btn\" expand=\"block\" [disabled]=\"!name\" (continue)=\"goContinue()\">\n        {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n"
    }),
    __metadata("design:paramtypes", [])
], UiCAccountNameComponent);

let UiCAccountNameModule = class UiCAccountNameModule {
};
UiCAccountNameModule = __decorate([
    NgModule({
        declarations: [UiCAccountNameComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCHeaderOnboardingModule,
        ],
        exports: [UiCAccountNameComponent]
    })
], UiCAccountNameModule);

export { UiCAccountNameComponent, UiCAccountNameModule };
//# sourceMappingURL=wlp-ui-c-account-name.js.map
